import React, { useState } from 'react';
import cn from 'classnames';
import { useDispatch } from 'react-redux';
import { useMatch } from 'react-router';
import { Link } from 'react-router-dom';
import centralLogo from 'src/assets/header-logo.svg';
import partnerLogo from 'src/assets/logo-121.png';
import { ROOT } from 'src/constants/routes';
import { useResponsive } from 'src/hooks';
import { useAppSelector } from 'src/hooks/store';
import { AppDispatch } from 'src/store';
import { setShowInfoPopup } from 'src/store/ui';
import { selectInfoPopup } from 'src/store/ui/selectors';
import { analytics } from 'src/utils/analytics';
import { lockBodyScroll } from 'src/utils/block-body-scroll';

import Icon from '../Icon';
import css from './Header.module.scss';
import { Socials } from './Socials';

type Props = {
  className?: string;
};

export default function Header({ className = '' }: Props) {
  const dispatch = useDispatch<AppDispatch>();
  const matchMain = useMatch(ROOT);
  const [isMobile] = useResponsive(['MOBILE', 'TABLET_P']);
  const isInfoPopupOpened = useAppSelector(selectInfoPopup);
  const hideCentralLogo = matchMain !== null;

  const n12Link = 'https://www.n12.co.il/';
  const partnerLink = '/';

  const onCentralLogoClick = () => {
    console.info('on sentral logo click');
  };

  const onInfoBtnClick = () => {
    dispatch(setShowInfoPopup(!isInfoPopupOpened));
    analytics.gtag.event('פופ אפ הסבר בהאדר');
    lockBodyScroll();
  };

  return (
    <header className={cn(css.header, className)}>
      <div className={css.logos}>
        <a className={css.n12Logo} href={n12Link} target="_blank" rel="noopener noreferrer">
          <Icon type="n-12-logo" />
        </a>
        <div className={css.separator} />
        <span className={css.partnerLogo}>
          <img src={partnerLogo} alt="121" />
        </span>
      </div>

      {!hideCentralLogo && (
        <div className={cn(css.centralLogo)}>
          <Link to={ROOT} onClick={onCentralLogoClick}>
            <img src={centralLogo} alt="logo" />
          </Link>
        </div>
      )}

      <div className={css.actions}>
        <button type="button" className={css.infoBtn} onClick={onInfoBtnClick}>
          <Icon type="help" />
        </button>
        <Socials />
      </div>
    </header>
  );
}
